import pMemoize from "@-/com.npmjs.p-memoize";
import type { ComponentProps, ComponentType } from "react";
import { useAsyncComponent } from "@-/dev.improve.haniverse.lib.use-async-component";

type BarChartComponent = typeof import("react-native-gifted-charts/dist/BarChart").BarChart;
type BarChartProps = ComponentProps<BarChartComponent>;

const loadBarChart = pMemoize(async (): Promise<BarChartComponent> => {
  const { BarChart } = await import("react-native-gifted-charts/dist/BarChart");
  return BarChart;
});

function LoadedBarChart({
  Component,
  ...props
}: BarChartProps & { Component: ComponentType<BarChartProps> }) {
  return <Component {...props} />;
}

export function BarChart(props: BarChartProps) {
  const Component = useAsyncComponent(loadBarChart);
  return Component === null ? null : <LoadedBarChart Component={Component} {...props} />;
}
